import { render, staticRenderFns } from "./InvestmentInstitutions.vue?vue&type=template&id=de90073c&scoped=true"
import script from "./InvestmentInstitutions.vue?vue&type=script&lang=js"
export * from "./InvestmentInstitutions.vue?vue&type=script&lang=js"
import style0 from "./InvestmentInstitutions.vue?vue&type=style&index=0&id=de90073c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de90073c",
  null
  
)

export default component.exports